import React from 'react';
import { motion } from 'framer-motion';
import { Check, Globe, Lock, Shield, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabel, priceRegular, priceToday } from '../data/offer';
import { included } from '../data/lessonContent';
import { trackCheckout } from '../utils/pixel';
export function PricingSection() {
  return <section id="prix" className="py-20 px-4 bg-black relative" data-id="element-180" data-mp="1jarxse5060v7">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-gold/20 blur-[120px] rounded-full pointer-events-none" data-id="element-181" data-mp="1na0r5hw4rwq8" />
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-182" data-mp="1x8gmxy63ru62">
        <div className="text-center mb-10" data-id="element-183" data-mp="1x6vr8581y56m">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3" data-id="element-184" data-mp="2282w9wit8q9l">Tout ce que tu reçois — pour {priceToday}</h2>
          <p className="text-gold-light text-sm md:text-base" data-id="element-185" data-mp="2w0fiu1km9zm">
            Le système 8 en 1 + les 5 bonus — prêts pour ton prochain cours.
          </p>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-card border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_50px_rgba(212,175,55,0.2)]" data-id="element-186" data-mp="1mh6ld1i2366i">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-187" data-mp="17rs9nmr0ccny">
            <Sparkles size={14} data-id="element-188" data-mp="20fxvydxpm9pw" /> Système complet 8 en 1
          </div>
          <div className="bg-black rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-189" data-mp="20emsygc395zu">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-gradient mb-3" data-id="element-190" data-mp="1vfjn4toaavqt">Prof d&apos;Espagnol Prêt</h3>
            <p className="text-base text-gray-300 mb-6" data-id="element-191" data-mp="k27nyw3gz1az">
              La bibliothèque pédagogique complète pour Spanish 1 et Spanish 2 — prête à utiliser dès aujourd&apos;hui.
            </p>
            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-gold/5 border border-gold/20 rounded-xl p-4" data-id="element-192" data-mp="g2yuztg977gh">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-193" data-mp="mfjhninfa3n4">
                  <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-194" data-mp="7ik8hqcxa2qj" />
                  <span data-id="element-195" data-mp="ci5euluf9dda">{item}</span>
                </li>)}
            </ul>
            <div className="mb-6" data-id="element-196" data-mp="3uwxunsnmp84o">
              <span className="text-lg text-gray-500 line-through block mb-1" data-id="element-197" data-mp="3uvw92u8zl38p">{priceRegular}</span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-198" data-mp="3is65ve4gstm">
                <span className="text-2xl md:text-3xl text-white" data-id="element-199" data-mp="3kz07l8hi9hdn">AUJOURD&apos;HUI :</span>
                <span className="text-4xl md:text-5xl font-bold text-gold" data-id="element-200" data-mp="3pxbgngzz7nut">{priceToday}</span>
              </div>
            </div>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-201" data-mp="3bz3f0vrzvydb">
              {ctaLabel}
            </Button>
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-400 mb-4" data-id="element-202" data-mp="2sca0778kmwia">
              <span className="flex items-center gap-1.5" data-id="element-203" data-mp="36cazii96tvvn">
                <Lock size={12} className="text-gold" data-id="element-204" data-mp="369oscjq7lidy" /> Paiement sécurisé
              </span>
              <span className="flex items-center gap-1.5" data-id="element-205" data-mp="31bdjocbnhdxb">
                <Zap size={12} className="text-gold" data-id="element-206" data-mp="3g95wgwptbo7t" /> Accès immédiat
              </span>
              <span className="flex items-center gap-1.5" data-id="element-207" data-mp="3bbe2zy9iru1i">
                <Shield size={12} className="text-gold" data-id="element-208" data-mp="3b8rwm1yd7kkv" /> Garantie 7 jours
              </span>
            </div>
            <div className="bg-white/5 border border-white/10 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-209" data-mp="3l0nxfkru5oss">
              <Globe className="text-gold shrink-0 mt-0.5" size={14} data-id="element-210" data-mp="2u9nry0lo107" />
              <p className="text-[11px] text-gray-400 leading-snug" data-id="element-211" data-mp="3u1dtmpl0dh71">
                Tu paies dans ta devise locale. Le montant s&apos;ajuste automatiquement selon ton pays.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}